import { Form } from 'antd';
import { useWizard } from '../../../components/wizard/useWizard';
import { useCallback, useEffect } from 'react';
import { FamilyMemberDetailsForm } from '../../../components/FamilyMemberDetailsForm';
import { FamilyMemberDetailsType } from '../../../components/FamilyMemberDetailsType';
import { useNewApplication } from './useNewApplication';

export const FamilyMemberDetailsStep = () => {
	const {
		familyMemberContactDetails,
		setFamilyMemberContactDetails,
		applicationDetails,
	} = useNewApplication();
	const [form] = Form.useForm<FamilyMemberDetailsType>();
	const { setNextButtonDisabled, setCancelButtonDisabled } = useWizard();
	const values = Form.useWatch<FamilyMemberDetailsType>([], form);

	const handleFormValuesChange = useCallback(async () => {
		try {
			const fieldValues = await form.validateFields({ validateOnly: true });
			setNextButtonDisabled(false);
			setFamilyMemberContactDetails(fieldValues);
		} catch (e) {
			const fields = e as { values: FamilyMemberDetailsType };
			setNextButtonDisabled(true);
			setFamilyMemberContactDetails(fields.values);
		}
		setCancelButtonDisabled(false);
		// eslint-disable-next-line
	}, [
		form,
		setFamilyMemberContactDetails,
		setCancelButtonDisabled,
		setNextButtonDisabled,
	]);

	useEffect(() => {
		void handleFormValuesChange();
	}, [handleFormValuesChange, values]);

	useEffect(() => {
		form.setFieldsValue(familyMemberContactDetails);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [form]);

	return (
		<FamilyMemberDetailsForm
			form={form}
			applicationDetails={applicationDetails}
		/>
	);
};
